import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicNetworkFirewallRulesetListParamsRaw,
	type LWApiPublicNetworkFirewallRulesetListResultRaw,
} from '@liquidweb-dev/club-sauce/public/network/firewall/ruleset/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const NETWORK_FIREWALL_RULESET_LIST_QUERY_KEY =
	'/network/firewall/ruleset/list';

const useNetworkFirewallRulesetList = (
	params: LWApiPublicNetworkFirewallRulesetListParamsRaw,
	options?: UseQueryOptions<
		LWApiPublicNetworkFirewallRulesetListResultRaw,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [NETWORK_FIREWALL_RULESET_LIST_QUERY_KEY, params],
		queryFn: () => api.network.firewall.ruleset.apiRaw.list(params),
		...options,
	});

export default useNetworkFirewallRulesetList;
